module.exports = __webpack_public_path__ + "static/img/11areaB_09.addc657.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/11areaB_09.png
// module id = 1089
// module chunks = 1